import { Link } from "@tanstack/react-router";
import {
  ArrowRight,
} from "lucide-react";
import { TECH_STACK } from "../data/tech-stack";
import StackCard from "../components/stack-card";

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="w-full border-b border-neutral-100 bg-gradient-to-b py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center text-center">
            <div className="mb-6 flex gap-2">
              <svg viewBox="0 0 171.653 146" xmlns="http://www.w3.org/2000/svg" width="117.57" height="100" fill="none">
                <path id="lingke logo" d="M73.0904 62.8548L73.0904 39.6849C73.0904 36.8485 74.8328 34.304 77.4769 33.2795L162.097 0.471037C166.592 -1.27162 171.437 2.03602 171.451 6.85661L171.487 19.4666C171.487 22.2977 169.766 24.844 167.13 25.8799L73.0904 62.8548ZM26.3599 20.3141C26.3599 9.05354 34.9706 2.42976 44.2442 2.42976C53.5178 2.42976 62.7906 10.3783 62.7906 20.3141C62.7906 30.2499 54.1799 38.8605 44.2442 38.8605C34.3085 38.8605 26.3599 31.5749 26.3599 20.3141ZM73.0904 62.8548L73.0904 90.2017L4.46258 64.5242C1.77865 63.5204 0 60.9553 0 58.0896L0 44.9525C0 40.1392 4.82102 36.8184 9.31803 38.5334L73.0904 62.8548ZM150.337 61.1743L162.351 56.6255C166.845 54.9243 171.653 58.2451 171.653 63.0506L171.653 123.884L171.511 139.188C171.467 143.886 166.826 147.155 162.388 145.615L73.4168 114.733L73.0904 90.2017L145.899 114.733L145.899 67.5994C145.899 64.7432 147.666 62.1859 150.337 61.1743ZM17.4942 118.32L17.4942 105.078C17.4942 100.358 22.1434 97.0442 26.6046 98.5831L73.4168 114.733L73.2029 132.682C73.1471 137.355 68.5442 140.609 64.1208 139.104L22.1512 124.823C19.3671 123.876 17.4942 121.261 17.4942 118.32Z" fill="rgb(0,0,0)" fill-rule="evenodd" />
              </svg>
            </div>
            <h1 className="mb-6 bg-gradient-to-r from-stone-950 to-neutral-950 bg-clip-text text-3xl font-bold text-transparent md:text-5xl">
              请登录你的账户
              <br />
            </h1>
            <p className="mb-8 max-w-2xl text-xl text-gray-600">
              只需一个 One Account 账户，即可访问 Lingke 所有内容。
            </p>
            <div className="flex flex-col gap-4 md:flex-row">
              <Link
                to="/dashboard"
                className="flex items-center justify-center gap-2 rounded-full bg-neutral-950 px-6 py-3 text-white transition hover:bg-neutral-900"
              >
                已有账户？立即登录 <ArrowRight className="h-4 w-4" />
              </Link>
              {/* <a
                href={import.meta.env.VITE_GITHUB_REPO_URL || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 rounded-full border border-gray-300 px-6 py-3 transition hover:bg-gray-50"
              >
                View on GitHub <GitBranch className="h-4 w-4" />
              </a>*/}
            </div>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-2xl font-bold text-gray-900 md:text-3xl">
            One Account 优势
          </h2>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
            {TECH_STACK.map((item, index) => (
              <StackCard key={index} {...item} />
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default LandingPage;
